import React__default from 'react';

var useWindowSize = function (delay) {
    if (delay === void 0) { delay = 300; }
    var _a = React__default.useState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
    }), windowSize = _a[0], setWindowSize = _a[1];
    React__default.useEffect(function () {
        var timeoutId;
        var handleResize = function () {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                setWindowSize({
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight,
                });
            }, delay);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', handleResize);
        };
    }, [delay]);
    return windowSize;
};

export { useWindowSize as default };
//# sourceMappingURL=useWindowSize.js.map
